import React, { useState } from 'react'
import Modal from 'react-modal'

function Tip (props) {
  const [modalIsOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  return (
    <>
      <button className='tooltip' onClick={openModal}>Tip</button>

      <Modal
        isOpen={modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={closeModal}
        className='tip-modal'
      >
        <div className='description' dangerouslySetInnerHTML={{ __html: props.content }} />
        {typeof props.button === 'string' ? <footer><button onClick={() => closeModal()}>{props.button}</button></footer> : null}
      </Modal>
    </>
  )
}

export default Tip
